import {
  AutoPayEnrollRequest,
  PostAutoPayEnrollmentResponse,
  PostAutoPayEnrollRequest,
} from '@aaa-ncnu-ie/mypolicy-api-billing';

import axios from '../axios';

export interface EnrollInAutoPayArgs {
  policies: AutoPayEnrollRequest[];
}

export const enrollInAutoPay = async ({ policies }: EnrollInAutoPayArgs) => {
  const requestBody: PostAutoPayEnrollRequest = {
    policies,
  };

  const response = await axios.post<PostAutoPayEnrollmentResponse>(
    `${
      import.meta.env.VITE_MYPOLICY_BILLING_API_URL
    }/v1/payment/autopay/enrollment`,
    requestBody,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    }
  );

  return response;
};
